import classNames from "classnames";
import moment from "moment";
import React from "react";
import { formatWrittenDayMonthYear } from "utilities";

interface Props {
  format: "regular" | "big" | "huge"
  eventDescription: string
  venueDescription?: string
  dateTime: server.dto.AppointmentDateTime
}

const LinkedShowLines = (props: Props) => {

  const { eventDescription, venueDescription, format } = props;

  const showPopularDateMoment = moment.utc(props.dateTime.startDisplay);

  const twoLineClases = classNames("linked-show-description-container two-lines", format);

  const threeLineClases = classNames("linked-show-description-container three-lines", format);

  let showName: string = eventDescription ?? "...";
  if (venueDescription && venueDescription.length > 1) {
    showName += ` @ ${venueDescription}`;
  }

  return <>
    <div className={twoLineClases}>
      <div className="linked-show-title">
        {showName}
      </div>

      <div className="linked-show-date text-sublabel">
        {formatWrittenDayMonthYear(showPopularDateMoment)}
      </div>
    </div>

    <div className={threeLineClases}>
      <div className="linked-show-title">
        {eventDescription}
      </div>

      {(venueDescription?.length > 1) && <div className="linked-show-subTitle">{venueDescription}</div>}

      <div className="linked-show-date text-sublabel">
        {formatWrittenDayMonthYear(showPopularDateMoment)}
      </div>
    </div>
  </>;
};

export default LinkedShowLines;
